import * as actions from '../actions/quotes';
import * as ActionTypes from '../actions/index';
import xs from 'xstream';
import BASE_URL from './variables';
import { getArrayPamaterer } from '../helpers/functions';


export function requestQuotesSuggestions(sources) {

    const request$ = sources.ACTION
        .filter(action => action.type === ActionTypes.GET_QUOTES_SUGGESTIONS)
        .map(action => ({
            url: BASE_URL + 'api/quotes/forms' +
                '?limit=' +  action.payload.limit +
                '&offset=' + action.payload.offset +
                '&shallow=true' +
                (getArrayPamaterer(action.payload.selectedQuoteStatuses,'statuses')?
                `&${getArrayPamaterer(action.payload.selectedQuoteStatuses,'statuses')}`:'') +
                (action.payload.search?('&search=' + action.payload.search):''),
            category: 'requestQuotesSuggestions',
            method: 'GET',
            type: 'application/json',
            withCredentials: true
        }));

    let httpResponse$ = sources.HTTP
        .select('requestQuotesSuggestions')
        .map((response) =>
            response.replaceError((err) => xs.of(err))
        )
        .flatten()
        .filter(response => response.status === 200)
        .map(response => actions.getQuotesSuggestionsSuccess(response));

    return {
        ACTION: httpResponse$,
        HTTP: request$
    };
}

export function requestQuotesSuggestionsFailed(sources) {
    let httpResponse$ = sources.HTTP
        .select('requestQuotesSuggestions')
        .map((response) =>
            response.replaceError((err) => xs.of(err))
        )
        .flatten()
        .filter(response => response.status !==200)
        .map(response => actions.getQuotesSuggestionsFailed(response));

    return {
        ACTION: httpResponse$
    };
}

export function requestQuotes(sources) {

    const request$ = sources.ACTION
        .filter(action => action.type === ActionTypes.GET_QUOTES)
        .map(action => ({
            url: BASE_URL + 'api/quotes/forms' +
                '?limit=' +  action.payload.limit +
                '&offset=' + action.payload.offset +
                '&shallow=true' +
                (getArrayPamaterer(action.payload.selectedBrokerFirms,'brokerFirmIds')?
                `&${getArrayPamaterer(action.payload.selectedBrokerFirms,'brokerFirmIds')}`:'') +
                (getArrayPamaterer(action.payload.selectedQuoteStatuses,'statuses')?
                `&${getArrayPamaterer(action.payload.selectedQuoteStatuses,'statuses')}`:'') +
                (action.payload.search?('&search=' + action.payload.search):'') +
                (getArrayPamaterer(action.payload.postcodes,'postcodes')?
                    `&${getArrayPamaterer(action.payload.postcodes,'postcodes')}`:''),
                
            category: 'requestQuotes',
            method: 'GET',
            type: 'application/json',
            withCredentials: true
        }));

    let httpResponse$ = sources.HTTP
        .select('requestQuotes')
        .map((response) =>
            response.replaceError((err) => xs.of(err))
        )
        .flatten()
        .filter(response => response.status === 200)
        .map(response => actions.getQuotesSuccess(response));

    return {
        ACTION: httpResponse$,
        HTTP: request$
    };
}

export function requestQuotesFailed(sources) {
    let httpResponse$ = sources.HTTP
        .select('requestQuotes')
        .map((response) =>
            response.replaceError((err) => xs.of(err))
        )
        .flatten()
        .filter(response => response.status !==200)
        .map(response => actions.getQuotesFailed(response));

    return {
        ACTION: httpResponse$
    };
}